import type { ReactNode } from 'react';

import styles from './centralized-layout.module.css';

export const CentrializedLayout = ({ children }: { children: ReactNode }) => {
  return (
    <div className={styles.layout}>
      <div className={styles.content}>{children}</div>
    </div>
  );
};
